"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconAllRisksFilled = function IconAllRisksFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.5 19H40V15.5C40 15.1022 39.842 14.7206 39.5607 14.4393C39.2794 14.158 38.8978 14 38.5 14C38.1022 14 37.7206 14.158 37.4393 14.4393C37.158 14.7206 37 15.1022 37 15.5V19H33.5C33.1022 19 32.7206 19.158 32.4393 19.4393C32.158 19.7206 32 20.1022 32 20.5C32 20.8978 32.158 21.2794 32.4393 21.5607C32.7206 21.842 33.1022 22 33.5 22H37V25.5C37 25.8978 37.158 26.2794 37.4393 26.5607C37.7206 26.842 38.1022 27 38.5 27C38.8978 27 39.2794 26.842 39.5607 26.5607C39.842 26.2794 40 25.8978 40 25.5V22H43.5C43.8978 22 44.2794 21.842 44.5607 21.5607C44.842 21.2794 45 20.8978 45 20.5C45 20.1022 44.842 19.7206 44.5607 19.4393C44.2794 19.158 43.8978 19 43.5 19Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 20.5C29.9848 20.6663 29.9848 20.8337 30 21H27V41.5C27.0016 42.1303 26.8711 42.754 26.6168 43.3308C26.3625 43.9076 25.9902 44.4246 25.5238 44.8486C25.0574 45.2727 24.5072 45.5942 23.9089 45.7925C23.3106 45.9908 22.6773 46.0615 22.05 46C20.9139 45.8546 19.8717 45.2941 19.124 44.4264C18.3763 43.5587 17.9759 42.4452 18 41.3V38C17.9957 37.7061 18.0563 37.4149 18.1773 37.1471C18.2983 36.8793 18.4769 36.6415 18.7003 36.4505C18.9238 36.2596 19.1865 36.1202 19.4699 36.0423C19.7533 35.9645 20.0504 35.95 20.34 36C20.8223 36.0971 21.2543 36.3627 21.5584 36.7494C21.8626 37.1361 22.0192 37.6184 22 38.11V41.5C22 41.6326 22.0527 41.7598 22.1464 41.8536C22.2402 41.9473 22.3674 42 22.5 42C22.6326 42 22.7598 41.9473 22.8536 41.8536C22.9473 41.7598 23 41.6326 23 41.5V21H7.34C7.26195 20.9984 7.18531 20.9789 7.11599 20.9431C7.04666 20.9072 6.98649 20.8559 6.94012 20.7931C6.89374 20.7303 6.86241 20.6577 6.84852 20.5809C6.83463 20.504 6.83856 20.4251 6.86 20.35C7.96565 16.8103 10.083 13.6715 12.951 11.3207C15.8189 8.96977 19.3122 7.50955 23 7.12V6C22.9957 5.70614 23.0563 5.41493 23.1773 5.14712C23.2983 4.87931 23.4769 4.64146 23.7003 4.45051C23.9238 4.25956 24.1865 4.12019 24.4699 4.04233C24.7533 3.96446 25.0504 3.95001 25.34 4C25.8223 4.09707 26.2543 4.36275 26.5584 4.7494C26.8626 5.13605 27.0192 5.61841 27 6.11V7.11C31.0719 7.53467 34.8965 9.26798 37.9 12.05C37.0868 12.1895 36.3493 12.6125 35.8184 13.2441C35.2875 13.8757 34.9976 14.6749 35 15.5V17H33.5C32.5717 17 31.6815 17.3688 31.0251 18.0251C30.3687 18.6815 30 19.5717 30 20.5Z",
    fill: color
  }));
};

IconAllRisksFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconAllRisksFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconAllRisksFilled;
exports.default = _default;